/** Processes screen strings (phase 1, block "processes"). */
export const processes = {
  'processes.title': 'Процеси',
  'processes.new': 'Новий процес',
  'processes.intro': 'Процес = що робити + розклад. У фазі 1 кожне спрацювання створює задачу людині; з фази 5 — план для агентів.',
  'processes.col.name': 'Назва',
  'processes.col.business': 'Бізнес',
  'processes.col.schedule': 'Розклад',
  'processes.col.next': 'Наступний запуск',
  'processes.col.last': 'Останній',
  'processes.col.owner': 'Власник',
  'processes.col.enabled': 'Увімкнено',
  'processes.runNow': 'Запустити зараз',
  'processes.runQueued': 'Поставлено в чергу: задача з’явиться протягом хвилини.',
  'processes.empty': 'Процесів ще немає',
  'processes.noBusinesses': 'Спочатку створи бізнес у розділі «Бізнеси».',
  'processes.tomorrow': 'завтра',
  'processes.last.task': '{when} · задача {key}',
  'processes.last.overdue': '{when} · прострочено SLA',
  'processes.disabled': 'вимкнено',

  'processes.edit.title': 'Процес · {name}',
  'processes.edit.new': 'Новий процес',
  'processes.form.name': 'Назва',
  'processes.form.business': 'Бізнес',
  'processes.form.description': 'Опис',
  'processes.form.repeat': 'Повторювати',
  'processes.form.day': 'День',
  'processes.form.time': 'Час',
  'processes.form.cron': 'cron (5 полів: хвилина година день місяць день-тижня)',
  'processes.form.cronLine': 'cron: {cron} · {tz}',
  'processes.form.timezone': 'Часовий пояс',
  'processes.form.sla': 'SLA, хвилин на виконання',
  'processes.form.owner': 'Власник',
  'processes.form.none': '—',
  'processes.form.save': 'Зберегти',
  'processes.form.create': 'Створити',
  'processes.form.enable': 'Увімкнути',
  'processes.form.disable': 'Вимкнути',
  'processes.form.saved': 'Збережено',
  'processes.form.mobileHint': 'На мобільному форма розгортається в одну колонку.',

  'processes.repeat.daily': 'щодня',
  'processes.repeat.weekly': 'щотижня',
  'processes.repeat.monthly': 'щомісяця',
  'processes.repeat.custom': 'cron вручну',
  'processes.weekday.1': 'понеділок',
  'processes.weekday.2': 'вівторок',
  'processes.weekday.3': 'середа',
  'processes.weekday.4': 'четвер',
  'processes.weekday.5': 'п’ятниця',
  'processes.weekday.6': 'субота',
  'processes.weekday.7': 'неділя',
  'processes.monthday': '{day}-го числа',

  'processes.schedule.daily': 'щодня о {time}',
  'processes.schedule.weekly.1': 'щопонеділка о {time}',
  'processes.schedule.weekly.2': 'щовівторка о {time}',
  'processes.schedule.weekly.3': 'щосереди о {time}',
  'processes.schedule.weekly.4': 'щочетверга о {time}',
  'processes.schedule.weekly.5': 'щоп’ятниці о {time}',
  'processes.schedule.weekly.6': 'щосуботи о {time}',
  'processes.schedule.weekly.7': 'щонеділі о {time}',
  'processes.schedule.monthly': '{day}-го числа о {time}',
  'processes.schedule.cron': '{cron}',
  'processes.schedule.none': 'без розкладу',

  'processes.template.title': 'Шаблон задачі, яку створює процес',
  'processes.template.name': 'Назва',
  'processes.template.description': 'Опис',
  'processes.template.assignee': 'Виконавець',
  'processes.template.priority': 'Пріоритет',
  'processes.template.project': 'Проєкт',
  'processes.template.hint': 'У назві й описі працюють підстановки {{date}} (дата спрацювання) і {{week}} (тиждень, напр. 2026-W36).',

  'processes.runs.title': 'Спрацювання',
  'processes.runs.col.scheduled': 'Заплановано',
  'processes.runs.col.created': 'Створено',
  'processes.runs.col.task': 'Задача',
  'processes.runs.col.status': 'Статус задачі',
  'processes.runs.col.closed': 'Закрито',
  'processes.runs.empty': 'Спрацювань ще не було',
  'processes.runs.manual': 'вручну',
  'processes.overdue': 'прострочено SLA',
} as const;
